var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-container"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"badge",class:[
      _vm.hidden ? 'is-hidden' : '',
      _vm.size,
      _vm.horizontalPosition,
      _vm.verticalPosition,
      _vm.color
    ],style:(_vm.badgePosition),attrs:{"aria-label":_vm.ariaLabel}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }